(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drexey-diamond-size"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dx-diamond-size')) {
    customElements.define(
      'dx-diamond-size',
      class extends HTMLElement {
        connectedCallback() {
          if (this.events) return;
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.range = this.querySelector('.dx-diamond__range');
          this.mobileToggle = this.querySelector('[data-mobile-toggle]');
          if (!this.range || !this.slides.length) return;
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          this.mobileToggle?.addEventListener(
            'click',
            () => {
              if (!window.matchMedia('(max-width: 749px)').matches) return;
              const isOpen = this.classList.toggle('is-mobile-open');
              this.mobileToggle.setAttribute('aria-expanded', String(isOpen));
            },
            options
          );
          this.ticks = Array.from(this.querySelectorAll('[data-index]'));
          this.caratValues = this.slides.map((slide) => Number.parseFloat(slide.dataset.carat));
          this.minCarat = Math.min(...this.caratValues);
          this.maxCarat = Math.max(...this.caratValues);
          this.range.min = String(this.minCarat);
          this.range.max = String(this.maxCarat);
          this.range.step = 'any';
          this.range.addEventListener('input', () => {
            const carat = Number.parseFloat(this.range.value);
            const closestIndex = this.caratValues.reduce((closest, value, index) =>
              Math.abs(value - carat) < Math.abs(this.caratValues[closest] - carat) ? index : closest, 0);
            this.select(closestIndex);
          }, options);
          this.ticks.forEach((button) => {
            const carat = Number.parseFloat(button.dataset.carat);
            button.style.setProperty('--dx-tick', `${this.getCaratPosition(carat)}%`);
            button.addEventListener('click', () => this.select(Number(button.dataset.index)), options);
          });
          this.querySelector('.dx-diamond__brightness input')?.addEventListener(
            'input',
            (event) => {
              this.style.setProperty('--dx-brightness', Number(event.target.value) / 100);
            },
            options
          );
          this.updateDiamondPosition = (index) => {
            const slide = this.slides[index];
            if (!slide) return;
            this.style.setProperty('--dx-diamond-size', `${slide.dataset.diamondSize}%`);
            this.style.setProperty('--dx-diamond-x', `${slide.dataset.diamondX}%`);
            this.style.setProperty('--dx-diamond-y', `${slide.dataset.diamondY}%`);
            this.style.setProperty('--dx-diamond-size-mobile', `${slide.dataset.diamondSizeMobile}%`);
            this.style.setProperty('--dx-diamond-x-mobile', `${slide.dataset.diamondXMobile}%`);
            this.style.setProperty('--dx-diamond-y-mobile', `${slide.dataset.diamondYMobile}%`);
          };
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
              if (index !== -1) this.select(index);
            },
            options
          );
          this.select(Number(this.dataset.initial));
        }
        disconnectedCallback() {
          this.events?.abort();
          this.events = null;
        }
        getCaratPosition(carat) {
          if (!Number.isFinite(carat) || this.maxCarat === this.minCarat) return 0;
          return ((carat - this.minCarat) / (this.maxCarat - this.minCarat)) * 100;
        }
        select(index) {
          const selected = Math.max(0, Math.min(this.slides.length - 1, index));
          const slide = this.slides[selected];
          this.slides.forEach((item, position) => {
            item.hidden = position !== selected;
          });
          this.querySelectorAll('[data-index]').forEach((button, position) => {
            button.setAttribute('aria-pressed', String(position === selected));
          });
          this.querySelectorAll('[data-size]').forEach((label) => {
            label.textContent = slide.dataset.carat;
          });
          this.range.value = slide.dataset.carat;
          this.range.setAttribute('aria-valuetext', this.querySelector('.dx-diamond__bubble').textContent.trim());
          this.querySelector('.dx-diamond__scale').style.setProperty(
            '--dx-position',
            `${this.getCaratPosition(Number.parseFloat(slide.dataset.carat))}%`
          );
          this.updateDiamondPosition(selected);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drexey-image-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dx-image-selector')) {
    customElements.define(
      'dx-image-selector',
      class extends HTMLElement {
        connectedCallback() {
          if (this.events) return;
          this.items = Array.from(this.querySelectorAll('[data-item]'));
          this.copies = Array.from(this.querySelectorAll('[data-copy]'));
          this.mobileToggle = this.querySelector('[data-mobile-toggle]');
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          this.mobileToggle?.addEventListener(
            'click',
            () => {
              if (!window.matchMedia('(max-width: 749px)').matches) return;
              const isOpen = this.classList.toggle('is-mobile-open');
              this.mobileToggle.setAttribute('aria-expanded', String(isOpen));
            },
            options
          );
          this.items.forEach((item) => {
            item.addEventListener('click', () => this.select(item), options);
            item.addEventListener(
              'keydown',
              (event) => {
                const index = this.items.indexOf(item);
                let next;
                if (event.key === 'ArrowRight') next = (index + 1) % this.items.length;
                if (event.key === 'ArrowLeft') next = (index - 1 + this.items.length) % this.items.length;
                if (event.key === 'Home') next = 0;
                if (event.key === 'End') next = this.items.length - 1;
                if (next === undefined) return;
                event.preventDefault();
                this.select(this.items[next]);
                this.items[next].focus();
              },
              options
            );
          });
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const item = this.items.find((button) => button.dataset.item === event.detail.blockId);
              if (item) this.select(item);
            },
            options
          );
        }
        disconnectedCallback() {
          this.events?.abort();
          this.events = null;
        }
        select(selected) {
          this.items.forEach((item) => item.setAttribute('aria-pressed', String(item === selected)));
          this.copies.forEach((copy) => {
            copy.hidden = copy.dataset.copy !== selected.dataset.item;
          });
          const selectedTitle = selected.getAttribute('aria-label');
          const mobileTitle = this.mobileToggle?.querySelector('[data-mobile-selected]');
          if (mobileTitle) mobileTitle.textContent = selectedTitle;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var wrapObserver = null;

  function stripPageFromCollectionUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('page')) return;
      url.searchParams.delete('page');
      var qs = url.searchParams.toString();
      var clean = url.pathname + (qs ? '?' + qs : '') + url.hash;
      history.replaceState(history.state, document.title, clean);
    } catch (e) {}
  }

  function doLoadMore(btn) {
    if (btn.classList.contains('is--loading')) return;

    var href = btn.getAttribute('data-href');
    if (!href) return;

    var ajaxContainer = document.querySelector('[data-ntajax-container]');
    if (!ajaxContainer) return;

    var sectionId = '';
    try {
      var opts = JSON.parse(ajaxContainer.getAttribute('data-ntajax-options') || '{}');
      sectionId = opts.id || '';
    } catch (e) { return; }
    if (!sectionId) return;

    var fetchUrl = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

    btn.classList.add('is--loading');

    fetch(fetchUrl, { method: 'GET', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newContent = doc.querySelector('[data-contentlm-replace]');
        var newWrap = doc.querySelector('[data-wrap-lm]');
        var oldContent = document.querySelector('[data-contentlm-replace]');
        var oldWrap = document.querySelector('[data-wrap-lm]');

        if (newContent && oldContent) {
          // Isotope/Masonry 布局
          var isIsotope = oldContent.classList.contains('isotopet4s');
          if (isIsotope && window.jQuery && window.jQuery.fn.isotopet4s) {
            var $ = window.jQuery;
            var $newItems = $(newContent.innerHTML);
            $(oldContent).isotopet4s('appended', $newItems);
            // 等 Isotope layout 完成后重新初始化商品交互
            if (window.T4SThemeSP && window.T4SThemeSP.reinitProductGridItem) {
              $(oldContent).one('layoutComplete.isotope', function () {
                window.T4SThemeSP.reinitProductGridItem();
              });
            }
          } else {
            oldContent.insertAdjacentHTML('beforeend', newContent.innerHTML);
          }

          // 更新分页包装器
          if (newWrap && oldWrap) {
            oldWrap.innerHTML = newWrap.innerHTML;
          } else if (oldWrap) {
            oldWrap.style.display = 'none';
          }

          // 重新初始化商品卡片交互（Isotope 分支已经在 layoutComplete 中处理了）
          if (!isIsotope && window.T4SThemeSP && window.T4SThemeSP.reinitProductGridItem) {
            setTimeout(function () {
              window.T4SThemeSP.reinitProductGridItem();
            }, 300);
          }
          try { document.body.dispatchEvent(new CustomEvent('t4s:hideTooltip')); } catch (e) {}
        }

        stripPageFromCollectionUrl();
        btn.classList.remove('is--loading');
      })
      .catch(function (err) {
        console.error('[Load More]', err);
        btn.classList.remove('is--loading');
      });
  }

  function bindCollectionScrollLoad() {
    var main = document.querySelector('.t4s-main-collection-page');
    if (!main) return;

    var wrap = main.querySelector('[data-wrap-lm]');
    var btn = wrap && wrap.querySelector('[data-load-more]');

    if (!btn) return;

    // 仅点击加载，不自动滚动加载
    btn.addEventListener('click', function onClick(e) {
      e.stopPropagation();
      doLoadMore(btn);
    });
  }

  function watchLoadMoreWrap() {
    var main = document.querySelector('.t4s-main-collection-page');
    if (!main) return;
    var wrap = main.querySelector('[data-wrap-lm]');
    if (!wrap || wrapObserver) return;

    wrapObserver = new MutationObserver(function () {
      bindCollectionScrollLoad();
    });
    wrapObserver.observe(wrap, { childList: true, subtree: true });
  }

  function init() {
    bindCollectionScrollLoad();
    watchLoadMoreWrap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.t4s-main-collection-page')) {
      if (wrapObserver) {
        wrapObserver.disconnect();
        wrapObserver = null;
      }
      init();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
